import { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate, useParams } from "react-router-dom";
import { fetchEntityById } from "../../../apis/apiService";
import { Box } from "@mui/system";
import Loader from "../../../components/common/Loader";
// import { CustomNoRowsOverlay } from "../../projects/Project";
// import DeactivateUser from "../../../components/common/UserDeactivate";
import { CustomNoRowsOverlay } from "../../../components/common/OverlayGrid";

const UserProject = () => {
  const navigate = useNavigate();
  const [paginationModal, setPaginationModal] = useState({
    page: 0,
    pageSize: 10,
  });
  const [loading, setLoadding] = useState(false);
  const { id } = useParams();
  const columns = [
    { field: "project_id", headerName: "ID", sortable: true, width: 100 },
    {
      field: "title",
      headerName: "Projects",
      sortable: true,
      width: 200,
      headerClassName: "custom-header",
    },
    { field: "owner_name", headerName: "Owner", sortable: true, width: 150 },
    {
      field: "current_status_name",
      headerName: "Status",
      width: 120,
      renderCell: (params) => {
        const status = params.value;
        let color = "red"; // Default color is red

        // Check if the status is either 'Completed' or 'Hold'
        if (status === "Completed" || status === "Started") {
          color = "green";
        }

        return <span style={{ color: color }}>{status}</span>;
      },
    },
    {
      field: "completed_percentage",
      headerName: "Completed %",
      sortable: true,
      width: 150,
    },
    {
      field: "added_by_name",
      headerName: "Created By",
      width: 100,
    },
    {
      field: "start_date",
      headerName: "Start Date",
      sortable: true,
      width: 150,
    },
    { field: "end_date", headerName: "End Date", sortable: true, width: 150 },
    {
      field: "completed_tasks_percentage",
      headerName: "Task",
      width: 100,
    },
    {
      field: "completed_milestones_percentage",
      headerName: "Milestone",
      width: 100,
    },
    {
      field: "added_at",
      headerName: "Created Date",
      width: 150,
    },
    {
      field: "updated_at",
      headerName: "Last Modified Date",
      width: 150,
    },
    {
      field: "updated_name",
      headerName: "Last Modified By",
      width: 150,
    },
  ];
  const [projects, setProjects] = useState([]);

  const fetchProjects = async () => {
    setLoadding(true);
    try {
      const response = await fetchEntityById("getProjectDetails", id);
      const dataWithId = response.data.map((project) => ({
        ...project, // Spread original project properties
        id: project.project_id, // Add `id` property for DataGrid
      }));
      setProjects(dataWithId);
    } 
    catch (error) {
      console.error("Error fetching projects:", error);
    } 
    finally {
      setLoadding(false);
    }
  };
  useEffect(() => {
    fetchProjects();
  }, [id]);
  // const handleRowClick = (params) => {
  //   const { id, title } = params.row; // Extract `id` and `title` from the row data
  //   const formattedId = id.toString().replace(/\s+/g, '-'); // Format the `id` (if needed)

  //   navigate(`/projects/projectDetail/${formattedId}`, {
  //     state: { title }, // Pass `title` as state
  //   });
  // };
  return (
    <>
      <div style={{ height: "100%", width: "100%" }} className="bg-white p-3">
        <div className="overflow-hidden w-100">
          {/* <div className="d-flex align-items-center my-3 justify-content-end gap-2 ">
            <DeactivateUser
              url="user/deactivate"
              id={id}
              name="User"
              refetchList={fetchProjects}
            />
          </div> */}
          {loading ? (
            <Loader />
          ) : (
            <Box sx={{ height: projects.length === 0 ? 300 : "100%" }}>
              <DataGrid
                rows={projects}
                columns={columns}
                pagination
                paginationModel={paginationModal}
                onPaginationModelChange={setPaginationModal}
                pageSizeOptions={[10, 20, 30, 40]}
                slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                disableSelectionOnClick
                // getRowClassName={(params) => "project-row"} // Adds custom class
                // onRowClick={handleRowClick} // Handles row click navigation
                // getRowId={(row) => row.project_id}
                getRowId={(row) => row.project_id}
              />
            </Box>
          )}
        </div>
      </div>
    </>
  );
};

export default UserProject;
